module.exports = __webpack_public_path__ + "img/SES_235250009.687d1ec1.jpg";